/**
 * Utility function for conditional logic depending on the runtime environment
 * being Chromatic or not. Copied from [Storybook
 * source](https://github.com/chromaui/chromatic-cli/blob/main/isChromatic.js).
 * @param windowArg The window object whose navigator and/or location is used to
 * determine if running in Chromatic.
 * @returns Returns `true` if running within Chromatic, `false` otherwise.
 */
const isChromatic = (windowArg?: typeof window) => {
  const windowToCheck = windowArg || (typeof window !== "undefined" && window);

  return !!(
    windowToCheck &&
    (windowToCheck.navigator.userAgent.match(/Chromatic/) ||
      windowToCheck.location.href.match(/chromatic=true/))
  );
};

export default isChromatic;
